import api from './api';

const developerService = {
  // Create a new API key
  async createApiKey(name) {
    try {
      const response = await api.post('/developer/keys', { name });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // List all API keys
  async getApiKeys() {
    try {
      const response = await api.get('/developer/keys');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Revoke an API key
  async revokeApiKey(id) {
    try {
      const response = await api.delete(`/developer/keys/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default developerService;
